import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import BuyButton from '../Components/BuyButton';
import { add as addToCart } from '../Actions/Cart.action';
import { translate } from '../Services/translation';
import ConfirmDialogue from '../Components/ConfirmDialogue';
import { searchFacetRefresh } from '../Actions/FacetedSearch.action';

class BuyButtonContainer extends Component {
    constructor(props) {
        super(props);
        this.buttonRef = React.createRef();

        this.state = { confirmModalOpen: false };

        this.focusAccessoryDiv = () =>
        {
            setTimeout(() => {
                const accessoryDiv = document.getElementsByClassName('configurator-related-products');
                    if (accessoryDiv && accessoryDiv.length > 0) {
                        accessoryDiv[0].scrollIntoView();
                    }
                },
                800);
        }
        this.handleAddToCartClick = () => {
            if (this.props.productType === 'Car' || this.props.productType === 'UsedCars') {
                if (this.props.cart.orderRows.some(x => x.productType === 'Car' || x.productType === 'UsedCars')) {
                    this.setState({ confirmModalOpen: true });
                } else {
                    this.props.addToCart(this.buttonRef.current, this.props.articleNumber, this.props.quantityFieldId, this.props.productType);
                    this.focusAccessoryDiv();
                }
            }
            else {
                this.props.addToCart(this.buttonRef.current, this.props.articleNumber, this.props.quantityFieldId, this.props.productType);
            }
        }

        this.onModalClose = () => {
            this.setState({ confirmModalOpen: false });
        }

        this.onModalConfirm = () => {
            this.props.addToCart(this.buttonRef.current, this.props.articleNumber, this.props.quantityFieldId, this.props.productType);
            this.setState({ confirmModalOpen: false });
            this.focusAccessoryDiv();
        }

        this.isProductAlreadyInCart = () => {

            if (!this.props.cart.containsCarOrderRow &&
                this.props.productType !== "Car" && this.props.productType !== "UsedCars")
                return false;

            if (this.props.cart.orderRows.some(x => x.articleNumber === this.props.articleNumber)) {
                if (this.props.productType !== "Car" && this.props.productType !== "UsedCars")
                    return true;

                var carOrderRow = this.props.cart.orderRows.find(x => x.articleNumber === this.props.articleNumber);
                var tyrePart = carOrderRow.carParts.find(x => x.fieldId === 'TyreOption');
                if (!tyrePart)
                    return true;

                var selectedTyreId = this.props.cart.selectedTyreId;
                if (!selectedTyreId) return true;

                if (selectedTyreId === tyrePart.id) return true;
                return false;
            } else {
                return false;
            }
        }
    }

    render() {
        const header = translate('cart.swapcarheader');
        const text = translate('cart.swapcarincart');
        const buttonTextCancel = translate('cart.swapcarcancel');
        const buttonTextConfirm = translate('cart.swapcarconfirm');

        const requiresActionBeforePurchasable = !this.props.cart.containsCarOrderRow && this.props.productType !== "Car" && this.props.productType !== "UsedCars";
        const isAlreadyAddedToCart = this.isProductAlreadyInCart();
        const canNotBeAddedToCart = this.props.productCanbeaddedtocart === 'False';
        const tooltip = requiresActionBeforePurchasable ? translate('cart.validation.requirescarincart') : 
            isAlreadyAddedToCart ? translate('cart.validation.isaddedtocart') :
                canNotBeAddedToCart ? translate('cart.validation.cannotbeaddedtocart') : null;
        const tooltipColor = isAlreadyAddedToCart ? "success" : "red";

        const disabled = requiresActionBeforePurchasable || isAlreadyAddedToCart || canNotBeAddedToCart;
        return (
            <span ref={this.buttonRef}>
                <BuyButton {...this.props} tooltip={tooltip} tooltipcolor={tooltipColor} disabled={disabled}
                    onClick={this.handleAddToCartClick} />
                {this.state.confirmModalOpen &&
                    <ConfirmDialogue {...{ header, text, buttonTextCancel, buttonTextConfirm, onClose: this.onModalClose, onConfirm: this.onModalConfirm }} />
                }
            </span>
        );
    }
}

const mapStateToProps = state => {
    return {
        cart: state.cart,
    }
}


const mapDispatchToProps = dispatch => {
    return {
        addToCart: (buttonDomNode, articleNumber, quantityFieldId, productType) => {
            const nodeIdToShowNotification = buttonDomNode.id = Date.now();
            dispatch(addToCart({
                articleNumber,
                quantity: quantityFieldId ? document.getElementById(quantityFieldId) ? document.getElementById(quantityFieldId).value : 1 : 1,
                nodeIdToShowNotification,
                notificationMessage: translate('tooltip.addedtocart'),
                hash: Date.now(),
            }));
            //if (productType === 'Car' || productType === 'UsedCars') dispatch(searchFacetRefresh());
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BuyButtonContainer);